/**
 * Big horizontal marquee — accepts a list of tokens/labels rendered inline and
 * looped for continuous scroll. Colour of the accent dot cycles across items.
 */
export default function TextMarquee({
  items,
  accentColors = ["#1E5AF6", "#16A374", "#0B1220"],
  className = "",
  reverse = false,
  testId,
}) {
  const doubled = [...items, ...items];
  return (
    <div
      data-testid={testId}
      className={`marquee ${className}`}
      style={{ mask: undefined }}
    >
      <div
        className="marquee-track"
        style={reverse ? { animationDirection: "reverse" } : undefined}
      >
        {doubled.map((label, i) => (
          <div key={`${label}-${i}`} className="flex items-center gap-4 shrink-0">
            <span
              className="inline-block h-2 w-2 rounded-full"
              style={{ background: accentColors[i % accentColors.length] }}
            />
            <span className="font-display font-extrabold tracking-tighter text-4xl md:text-6xl lg:text-7xl">
              {label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
